var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnfilledBrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    role: "img",
    "aria-label": "MyAdvisorRetirement mark",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 51,
    r: 14,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FFFFFF",
    strokeWidth: 6.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,65V80.5",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FFFFFF",
    strokeWidth: 6.4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.55,75.85A27,27 0 1 0 20.88,66.49",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FFFFFF",
    strokeWidth: 6.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.82,91.25A41,41 0 0 0 38,10.31",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FFFFFF",
    strokeWidth: 6.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfilledBrain);
export default __webpack_public_path__ + "static/media/unfilledBrain.232a692d608f6346e4a9f5d5f4aeb7c4.svg";
export { ForwardRef as ReactComponent };